'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { toast } from '@/components/ui/use-toast';
import { accessRulesKeyPrefix, createInitialAccessRuleForm, useCreateAccessRule } from '@/features/authentication-policy';
import { handleApiError } from '@/lib/api/error';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { AccessRuleStepperScreen } from '../-components/AccessRuleStepperScreen';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/access-rules/new/')({
  component: NewAccessRulePage
});
const BASE_LINK = '/settings/authentication/access-rules/new';
function NewAccessRulePage() {
  const {
    i18n,
    t
  } = useTranslation(defaultNS, {
    keyPrefix: accessRulesKeyPrefix
  });
  const navigate = useNavigate();
  const createMutation = useCreateAccessRule();
  const [errorMessage, setErrorMessage] = useState('');
  const backToList = () => navigate({
    to: '/settings/authentication/access-rules'
  });
  return <AccessRuleStepperScreen baseLink={BASE_LINK} initialValue={createInitialAccessRuleForm()} isSubmitting={createMutation.isPending} errorMessage={errorMessage} onSubmit={body => {
    setErrorMessage('');
    createMutation.mutate(body, {
      onSuccess: () => {
        toast({
          description: t($ => $.toast.created)
        });
        void backToList();
      },
      onError: error => {
        setErrorMessage(handleApiError(error, {
          language: i18n.language
        }).message);
      }
    });
  }} />;
}